import { render, staticRenderFns } from "./changeGroupModal.vue?vue&type=template&id=3cf36692&scoped=true&lang=html&"
import script from "./changeGroupModal.vue?vue&type=script&lang=js&"
export * from "./changeGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./changeGroupModal.vue?vue&type=style&index=0&id=3cf36692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf36692",
  null
  
)

export default component.exports